import { Box, Typography } from "@mui/material";
import "../CSS/Layout.css";

export default function PageNotFound() {
  return (
    <Box className="display-center">
      <Typography sx={{ color: "var(--app-third)" }} fontSize={70}>
        Page Not Found.
      </Typography>
    </Box>
  );
}